import { render, staticRenderFns } from "./tabTags.vue?vue&type=template&id=44a87d25&"
import script from "./tabTags.vue?vue&type=script&lang=js&"
export * from "./tabTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports